import React from 'react';

export default function Picture({
  fill = '#355A88',
  width = 20,
  height = 20,
  className = '',
  style = {},
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      style={{ ...style }}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 17.8913C0 19.056 0.9481 20 2.1087 20H17.8913C19.056 20 20 19.0519 20 17.8913V2.1087C20 0.944013 19.0519 0 17.8913 0H2.1087C0.944013 0 0 0.9481 0 2.1087V17.8913ZM17.8912 18.9987H2.10865C1.49974 18.9987 1.00117 18.5001 1.00117 17.8912V15.2553L4.79357 11.4629L8.03427 14.7036C8.23043 14.8998 8.5451 14.8998 8.74126 14.7036L14.5933 8.85156L18.9987 13.257V17.8912C18.9987 18.5001 18.5002 18.9987 17.8912 18.9987ZM17.8912 1.00117H2.10865C1.49974 1.00117 1.00117 1.49974 1.00117 2.10865V13.8373L4.43803 10.4004C4.63419 10.2043 4.94886 10.2043 5.14502 10.4004L8.38572 13.6411L14.2378 7.78907C14.4339 7.59292 14.7486 7.59292 14.9448 7.78907L18.9987 11.8389V2.10865C18.9987 1.49974 18.5002 1.00117 17.8912 1.00117ZM6.19949 8.01382C7.60529 8.01382 8.74546 6.86957 8.74546 5.46785C8.74546 4.06613 7.60121 2.92188 6.19949 2.92188C4.79777 2.92188 3.65352 4.06613 3.65352 5.46785C3.65352 6.86957 4.79369 8.01382 6.19949 8.01382ZM7.74418 5.46819C7.74418 4.61817 7.05354 3.92344 6.19944 3.92344C5.34533 3.92344 4.65469 4.61817 4.65469 5.46819C4.65469 6.31821 5.34942 7.01294 6.19944 7.01294C7.04946 7.01294 7.74418 6.31821 7.74418 5.46819Z"
        fill={fill}
      />
    </svg>
  );
}
